import React, {useState} from "react";
import { Typography, Paper, FormControlLabel, Checkbox, FormGroup, Button } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import TopOfAddStepTables from "../../CellStepManagement/components/TopOfAddStepTables";
import StimTable from "../../CellStepManagement/components/StimTable";
import UploadStimPage from "../../Stims/components/UploadStimPage";
import PaginationBlock from "./PaginationBlock";
import Divider from "@mui/material/Divider";
import { maxHeight } from "@mui/system";

const StepTypeDistraction = ({
  newItem,
  toggleItem,
  handleClick,
  id,
  studyId,
  stepType,
  data,
  loading,
  rowsPerPage,
  currentPage,
  onPageChange,
  onRowsPerPageChange,
  onSearch,
  setHasSearched,
  hasSearched,
  resetStateToLoading,
  onSelectItem,
  handleStimUploadComplete,
  resultCount,
  onDone,
  cells = [],
}) => {
  // state for cell modal
  const [openCellModal, setOpenCellModal] = useState(false);
  const [selectedCells, setSelectedCells] = useState([]);
  const [pendingInstructionsIds, setPendingInstructionIds] = useState([]);

  console.log(cells)
  // confirming cell selection
  const handleAddStepsToCells = () => {
    selectedCells.forEach((cellId) => {
      if (pendingInstructionsIds.length > 0) {
        pendingInstructionsIds.forEach((instrId) => {
          handleClick(cellId, stepType, studyId, instrId, {closeAfter: false});
        });
      } else {
        handleClick(cellId, stepType, studyId);
      }
    });

    setOpenCellModal(false);
    setSelectedCells([]);
    setPendingInstructionIds([]);
    onDone?.();
  };

  return (
    <div style={{ width: "100%" }}>
      <div style={{ padding: "4px 0 12px", width: "100%" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 16,
            flexWrap: "wrap",
          }}
        >
          <div
            style={{
              minWidth: 220,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Typography variant="subtitle1" style={{ lineHeight: 1.2 }}>
              Add a new distraction step
            </Typography>

            <Typography
              variant="caption"
              color="textSecondary"
              style={{
                marginTop: 2,
                lineHeight: 1.2,
              }}
            >
              This step shows stimuli filtered as distractions
            </Typography>
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: 8,
              marginLeft: "auto",
              minWidth: 0,
              flex: 1,
              justifyContent: "flex-end",
            }}
          >
            <div style={{ width: "100%", maxWidth: 420 }}>
              <TopOfAddStepTables
                button
                buttonText="Distraction Step"
                buttonClick={() => {
                  setPendingInstructionIds([]);
                  setOpenCellModal(true);
                } }
                textFieldLabel="Search distractions"
                textFieldChange={(term) => {
                  onSearch(term);
                  if (term.length > 2) {
                    setHasSearched(true);
                    resetStateToLoading();
                    onSelectItem(stepType, studyId, term, rowsPerPage, currentPage);
                  }
                }}
              />
            </div>
          </div>
        </div>
      </div>

      <Paper
        elevation={0}
        square
        style={{
          padding: 0,
          borderRadius: 0,
          marginBottom: 24,
          background: "transparent",
        }}
      >
        {!newItem ? (
          <>
            <Divider
              sx={{
                borderColor: "rgba(0,0,0,0.08)",
              }}
            />

            {!hasSearched ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "64px 0",
                  color: "#888",
                  fontSize: "14px",
                }}
              >
                <SearchIcon style={{ fontSize: 50, marginBottom: 20 }} />
                <span>Search for a Distraction</span>
              </div>
            ) : (
              <>
                <StimTable
                  onAddAll={(selectedIds) => {
                    setPendingInstructionIds(selectedIds);
                    setOpenCellModal(true);
                  }}
                  loading={loading}
                  data={data}
                />

                <div
                  style={{
                    position: "sticky",
                    bottom: 0,
                    zIndex: 2,
                    background: "#fff",
                    padding: "8px 0",
                    borderTop: "1px solid rgba(0,0,0,0.08)",
                  }}
                >
                  <PaginationBlock
                    resultCount={resultCount}
                    rowsPerPage={rowsPerPage}
                    currentPage={currentPage}
                    onPageChange={onPageChange}
                    onRowsPerPageChange={onRowsPerPageChange}
                  />
                </div>
              </>
            )}
          </>
        ) : (
          <UploadStimPage
            onUploadComplete={handleStimUploadComplete}
            toggleItem={toggleItem}
            showBackButton={true}
            fromModal={true}
          />
        )}
      </Paper>

    {/* cell selection modal */}
    {openCellModal && (
      <div
        style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 99999,
          }}
        >
          <div style={{ background: "white", padding: 24, borderRadius: 8, width: 400 }}>
            <Typography variant="h6" style={{marginBottom: 12}}>
              Select Cells
            </Typography>

            <FormGroup style={{maxHeight: "60vh", overflowY: "auto"}}>
              {/* select all */}
              <FormControlLabel 
                control={
                  <Checkbox
                    checked={cells.length > 0 && selectedCells.length === cells.length}
                    onChange={() => {
                      if (selectedCells.length === cells.length) {
                        setSelectedCells([]);
                      } else {
                        setSelectedCells(cells.map((c) => c.id));
                      }
                    }}
                  />
                }
                label="Select All"
              />

              {/* select individual cells */}
              {cells.map((cell) => (
                <FormControlLabel
                  key={cell.id}
                  control={
                    <Checkbox
                      checked={selectedCells.includes(cell.id)}
                      onChange={() => {
                        if (selectedCells.includes(cell.id)) {
                          setSelectedCells(selectedCells.filter((cId) => cId !== cell.id));
                        } else {
                          setSelectedCells([...selectedCells, cell.id]);
                        }
                      }}
                    />
                  }
                  label={cell.cellName}
                />  
              ))}
            </FormGroup>

            <div style={{ marginTop: 16, display: "flex", justifyContent: "flex-start" }}>
              <Button onClick={() => setOpenCellModal(false)} style={{ marginRight: 8 }}>
                Cancel
              </Button>

              <Button
                disabled={selectedCells.length === 0}
                variant="contained"
                onClick={() => handleAddStepsToCells()}
              >
                Add to selected cells
              </Button>
            </div>
          </div>
        </div>
       )}
    </div>
  );
};

export default StepTypeDistraction;